import Learn_More_Frame from "../components/Learn_More_Frame";

const WHYCHOOSEUSLEARNMOREPAGE = ({ className = "" }) => {
  console.log("Received className:", className);
  return (
    <div
      className={`bg-skyblue p-8 flex flex-col lg:flex-row box-border gap-8 ${className}`}
    >
      <img
        className="w-full lg:w-[568px] rounded-2xl object-cover"
        alt=""
        src="/image-1@2x.png"
      />
      <Learn_More_Frame />
    </div>
  );
};

export default WHYCHOOSEUSLEARNMOREPAGE;
